import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { validateToken } from "../api/client";
import { useAuth } from "../store/auth";

interface FromState { from?: { pathname: string } }

export function Login() {
  const [token, setToken] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const setSession = useAuth((s) => s.setSession);
  const nav = useNavigate();
  const loc = useLocation();
  const dest = (loc.state as FromState | null)?.from?.pathname ?? "/";

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      const ok = await validateToken(token);
      if (!ok) {
        setErr("Token rejected by the orchestrator.");
        return;
      }
      setSession(token);
      nav(dest, { replace: true });
    } catch {
      setErr("Could not reach the orchestrator.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login">
      <h1>Evolution Console</h1>
      <p className="dim">AI Grand Prix · echo6 fleet</p>
      <form onSubmit={submit} className="login-form">
        <input
          type="password"
          placeholder="Access token"
          value={token}
          autoFocus
          onChange={(e) => setToken(e.target.value)}
        />
        <button type="submit" className="primary" disabled={busy}>
          {busy ? "Checking…" : "Connect"}
        </button>
        {err && <p style={{ color: "var(--bad)" }}>{err}</p>}
        <p className="dim" style={{ fontSize: "0.8rem" }}>
          Leave blank if the orchestrator runs without a token.
        </p>
      </form>
    </main>
  );
}
